import React from 'react';
import { ExtendedTheme, Heading } from 'neon-design-system';
import { createStyles, makeStyles } from '@material-ui/core';
import { useQuery } from '@apollo/react-hooks';
import { ListItem } from '../../shared/types';
import LinkList, { ListItemOrientation, ListItemType } from './LinkList';
import { GET_MONTHS_LIST } from '../../gql/articles';
import moment from 'moment';
import { baseUrls } from '../../utils/baseUrls.utils';


const useStyles = makeStyles<ExtendedTheme>((theme: ExtendedTheme) => createStyles({
	recentArticles: {
		marginBottom: theme.spacing(2)
	}
}));

interface YearMonthExt {
	year: number;
	month: number;
	asDate?: moment.Moment;
}

export const Archives: React.FC = () => {
	const classes = useStyles();

	const qryMonth = useQuery(GET_MONTHS_LIST, { fetchPolicy: 'network-only' });

	if (qryMonth.loading) return <></>;

	const loadedData: YearMonthExt[] = qryMonth?.data?.getLastMonthsWithArticles ?? [];

	const dataAsDate = loadedData.map(x => moment(new Date(x.year, x.month - 1, 1)));

	const recentArticles: ListItem[] = dataAsDate
		.map(date => ({
			id: date?.format('YYYY-MM') ?? '-',
			name: date?.format('MMMM YYYY') ?? '-',
			url: `${baseUrls.archives.main}/${date?.format('YYYY-MM')}`
		}));

	return (
		<div>
			<Heading
				className={classes.recentArticles}
				styleName="title1"
				xs="small"
				md="medium"
				xl="large"
			>
								Archives

			</Heading>
			<div id={'articles-archive'}>
				<LinkList
					disableSort
					items={recentArticles}
					orientation={ListItemOrientation.Vertical}
					displayType={ListItemType.Link}
					isSpacedVerticalLinks={true}
				/>
			</div>
		</div>
	);
};

export default Archives;
